"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));

var _isNumber = _interopRequireDefault(require("lodash/isNumber"));

var _Table = _interopRequireDefault(require("./Table/Table"));

var _Loading = _interopRequireDefault(require("./Loading/Loading"));

var _addRowKeys = _interopRequireDefault(require("./utils/addRowKeys"));

var _sortData = _interopRequireDefault(require("./utils/sortData"));

var _filterData = _interopRequireDefault(require("./utils/filterData"));

var _synchronizeCellSizes = _interopRequireDefault(require("./utils/synchronizeCellSizes"));

var _synchronizeTableTRSizes = _interopRequireDefault(require("./utils/synchronizeTableTRSizes"));

var _verticalScroll = _interopRequireDefault(require("./utils/verticalScroll"));

var _horizontalScroll = _interopRequireDefault(require("./utils/horizontalScroll"));

var _propTypes2 = require("./propTypes");

var _TableContainer = require("./TableContainer.style");

var _anyHasChildren = _interopRequireDefault(require("./utils/anyHasChildren"));

var _ColumnManager = _interopRequireDefault(require("./ColumnManager"));

var noop = function noop() {
  return null;
};

var TableContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TableContainer, _PureComponent);

  function TableContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TableContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TableContainer).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "expandTableRow", function (rowKey, rowData) {
      var currentExpandedIndexes = (0, _toConsumableArray2.default)(_this.state.expandedKeys);
      var currentIndex = currentExpandedIndexes.indexOf(rowKey);
      var expanded = currentIndex !== -1;

      if (!expanded) {
        currentExpandedIndexes.push(rowKey);
      } else {
        currentExpandedIndexes.splice(currentIndex, 1);
      }

      _this.setState({
        expandedKeys: currentExpandedIndexes
      }, function () {
        _this.props.onExpandRow(!expanded, rowData);

        var hasFixed = _this.columnManager.hasFixed();

        if (hasFixed) {
          (0, _synchronizeTableTRSizes.default)(_this.node);
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setRef", function (node) {
      _this.node = node;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "sortTable", function (key, reverse) {
      var sortState = {
        key: key,
        reverse: reverse
      };

      _this.setState({
        sortState: sortState
      });

      _this.props.onSort(sortState);

      _this.props.onChange({
        sortState: sortState,
        filterState: _this.state.filterState
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "filterTable", function (key, result) {
      var filterState = (0, _objectSpread3.default)({}, _this.state.filterState, (0, _defineProperty2.default)({}, key, result));

      _this.setState({
        filterState: filterState
      });

      _this.props.onFilter(filterState);

      _this.props.onChange({
        filterState: filterState,
        sortState: _this.state.sortState
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onDrop", function (dragIndex, dropIndex, dropped) {
      console.log('info:: ', dragIndex, dropIndex, dropped);
      var data = _this.state.data;
      var dragrow = data[dragIndex]; // console.log(data);

      _this.setState((0, _immutabilityHelper.default)(_this.state, {
        data: {
          $splice: [[dragIndex, 1], [dropIndex, 0, dragrow]]
        }
      }), function () {
        return dropped && _this.props.onRowDrop({
          dragIndex: dragIndex,
          dropIndex: dropIndex,
          dragrow: dragrow
        }, _this.state.data);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleRowHover", function (hoveredRowKey) {
      _this.setState({
        hoveredRowKey: hoveredRowKey
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleScroll", function (event) {
      var target = event.target;
      (0, _verticalScroll.default)(target);
      (0, _horizontalScroll.default)(target);
    });
    _this.state = {
      sortState: _this.props.defaultSort || _this.props.sortState,
      filterState: _this.props.defaultFilter || _this.props.filterState,
      hoveredRowKey: null,
      data: (0, _addRowKeys.default)(_this.props.data, _this.props.rowDataKey),
      expandedKeys: _this.props.expandedKeys
    };
    _this.columnManager = new _ColumnManager.default(_this.props.columns);
    return _this;
  }

  (0, _createClass2.default)(TableContainer, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        columnManager: this.columnManager
      };
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var data = _ref.data,
          rowDataKey = _ref.rowDataKey,
          sortState = _ref.sortState,
          filterState = _ref.filterState,
          columns = _ref.columns;
      this.state.data = (0, _addRowKeys.default)(data, rowDataKey);

      if (sortState !== this.props.sortState) {
        this.state.sortState = sortState;
      }

      if (filterState !== this.props.filterState) {
        this.state.filterState = filterState;
      }

      if (this.props.columns !== columns) {
        this.columnManager.reset(columns);
        var hasFixed = this.columnManager.hasFixed();

        if (hasFixed) {
          (0, _synchronizeTableTRSizes.default)(this.node);
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var hasFixed = this.columnManager.hasFixed();

      if (hasFixed) {
        (0, _synchronizeTableTRSizes.default)(this.node);
      }

      var fixedHeader = this.props.fixedHeader;
      var allFixed = hasFixed && fixedHeader;
      if (!allFixed) return;
      (0, _synchronizeCellSizes.default)(this.node);
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onRowClick = _this$props.onRowClick,
          showHeader = _this$props.showHeader,
          loading = _this$props.loading,
          rowHeight = _this$props.rowHeight,
          fixedHeader = _this$props.fixedHeader,
          maxBodyHeight = _this$props.maxBodyHeight,
          emptyConfig = _this$props.emptyConfig,
          primaryTableClassName = _this$props.primaryTableClassName,
          draggable = _this$props.draggable,
          setIcon = _this$props.setIcon,
          headerBordered = _this$props.headerBordered;
      var top = fixedHeader ? fixedHeader.top : 0;
      var _this$state = this.state,
          filterState = _this$state.filterState,
          hoveredRowKey = _this$state.hoveredRowKey,
          data = _this$state.data,
          sortState = _this$state.sortState;
      var hasFixedLeft = this.columnManager.hasFixedLeft();
      var hasFixedRight = this.columnManager.hasFixedRight();
      var hasFixed = this.columnManager.hasFixed();
      var leafColumns = this.columnManager.leafColumns();
      var filteredData = (0, _filterData.default)(data, leafColumns, filterState);
      var sortedData = (0, _sortData.default)(filteredData, leafColumns, sortState);
      var isAnyRowExpandable = (0, _anyHasChildren.default)(sortedData);
      var allFixed = hasFixed && fixedHeader;
      var tableProps = {
        data: sortedData,
        onRowClick: onRowClick,
        sortTable: this.sortTable,
        sortState: sortState,
        filterTable: this.filterTable,
        filterState: filterState,
        showHeader: showHeader,
        onDrop: this.onDrop,
        loading: loading,
        fixedHeader: fixedHeader,
        maxBodyHeight: maxBodyHeight,
        emptyConfig: emptyConfig,
        rowHeight: rowHeight,
        handleRowHover: this.handleRowHover,
        hoveredRowKey: hoveredRowKey,
        hasFixed: hasFixed,
        isAnyRowExpandable: isAnyRowExpandable,
        onExpandRow: this.expandTableRow,
        draggable: draggable,
        setIcon: setIcon,
        headerBordered: headerBordered,
        top: top,
        expandedKeys: this.state.expandedKeys
      };
      return _react.default.createElement("div", {
        className: (0, _TableContainer.containerStyles)(allFixed),
        onScroll: this.handleScroll,
        ref: this.setRef
      }, loading && _react.default.createElement(_Loading.default, null), hasFixedLeft && _react.default.createElement(_Table.default, (0, _extends2.default)({}, tableProps, {
        wrapperStyle: (0, _TableContainer.fixedColumnsStyle)('left'),
        tableType: "left"
      })), hasFixedRight && _react.default.createElement(_Table.default, (0, _extends2.default)({}, tableProps, {
        wrapperStyle: (0, _TableContainer.fixedColumnsStyle)('right'),
        tableType: "right"
      })), _react.default.createElement(_Table.default, (0, _extends2.default)({
        primaryTableClassName: primaryTableClassName
      }, tableProps, {
        wrapperStyle: (0, _TableContainer.mainColumnsStyle)(hasFixed),
        tableType: "main"
      })));
    }
  }]);
  return TableContainer;
}(_react.PureComponent);

(0, _defineProperty2.default)(TableContainer, "childContextTypes", {
  columnManager: _propTypes.default.any.isRequired
});
TableContainer.defaultProps = {
  onRowClick: null,
  loading: false,
  fixedHeader: null,
  maxBodyHeight: '500px',
  showHeader: true,
  emptyConfig: {
    label: 'No data',
    button: {}
  },
  rowHeight: null,
  onSort: noop,
  sortState: {},
  onFilter: noop,
  onChange: noop,
  onRowDrop: noop,
  filterState: [],
  rowDataKey: 'key',
  onExpandRow: noop,
  draggable: false,
  setIcon: false,
  headerBordered: false,
  expandedKeys: []
};
var sortPropType = {
  key: _propTypes.default.string,
  reverse: _propTypes.default.bool
};

var filterPropType = _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.string));

TableContainer.propTypes = {
  columns: _propTypes.default.arrayOf(_propTypes2.columnPropType).isRequired,
  data: _propTypes.default.arrayOf(_propTypes2.rowPropType).isRequired,
  loading: _propTypes.default.bool,
  onRowClick: _propTypes.default.func,
  fixedHeader: _propTypes.default.shape({
    top: _propTypes.default.string
  }),
  maxBodyHeight: _propTypes.default.string,
  showHeader: _propTypes.default.bool,
  emptyConfig: _propTypes.default.shape({
    label: _propTypes.default.string,
    button: _propTypes.default.shape({})
  }),
  rowHeight: function rowHeight(_ref2) {
    var columns = _ref2.columns,
        _rowHeight = _ref2.rowHeight;
    var hasFixed = columns.some(function (col) {
      return col.fixed;
    });

    if (hasFixed && !(0, _isNumber.default)(_rowHeight)) {
      return new Error('Please specify rowHeight if you provide fixed columns');
    }

    return null;
  },
  onSort: _propTypes.default.func,
  defaultSort: _propTypes.default.shape(sortPropType),
  sortState: _propTypes.default.shape(sortPropType),
  onFilter: _propTypes.default.func,
  defaultFilter: filterPropType,
  filterState: filterPropType,
  onChange: _propTypes.default.func,
  onRowDrop: _propTypes.default.func,
  rowDataKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  primaryTableClassName: _propTypes.default.string,
  onExpandRow: _propTypes.default.func,
  draggable: _propTypes.default.bool,
  setIcon: _propTypes.default.bool,
  headerBordered: _propTypes.default.bool,
  expandedKeys: _propTypes.default.arrayOf(_propTypes.default.string)
};
var _default = TableContainer;
exports.default = _default;